export function isBool(value) {
    return typeof value === 'boolean';
}

export function isImsId(value) {
    return !isNaN(value);
}
